import { FeeSchedule } from "../model";

export class FeeSchedulePostCommand{
    feeScheduleView: FeeSchedule;

    constructor(feeSchedle:FeeSchedule){
        this.feeScheduleView = feeSchedle;
    }
}